
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27","height":"27","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.15 25.972a12.101 12.101 0 01-3.26-3.329 1.452 1.452 0 00-2.426 1.597 14.987 14.987 0 004.04 4.123 1.45 1.45 0 101.646-2.391zM3.873 9.78a1.45 1.45 0 002.01-.416 12.095 12.095 0 013.259-3.33 1.452 1.452 0 00-1.648-2.39A14.988 14.988 0 003.457 7.77c-.44.67-.254 1.57.416 2.01zm.256 8.555a12.217 12.217 0 01-.003-4.66 1.452 1.452 0 00-2.85-.554 15.17 15.17 0 00.003 5.772 1.452 1.452 0 002.85-.558zM16 1a15.08 15.08 0 00-3.191.34 1.451 1.451 0 10.614 2.838A12.223 12.223 0 0116 3.903c6.67 0 12.097 5.427 12.097 12.097S22.67 28.097 16 28.097c-.869 0-1.735-.093-2.577-.275a1.451 1.451 0 10-.614 2.837A15.08 15.08 0 0016 31c8.271 0 15-6.729 15-15S24.271 1 16 1z","fill":"#fff","data-original":"#000000"}}),_c('path',{attrs:{"d":"M12.206 22.572a1.448 1.448 0 001.451 0l9.206-5.315a1.451 1.451 0 000-2.514l-9.206-5.315a1.451 1.451 0 00-2.177 1.257v10.63c0 .519.277.998.726 1.257zm2.177-9.373L19.234 16l-4.851 2.8z","fill":"#fff","data-original":"#000000"}})])
          )
        }
      }
    